import { getCollapsedDrawerSections } from 'selectors';
import { StandardThunkAction } from 'types';
import { actionCreator } from 'util/actions';
import {
  getSidebarValues,
  setSidebarValues,
} from 'util/application-storage/sidebar';
import { createReducer } from 'util/reducers';

// Types
interface Collapsible {
  open: boolean;
}
export interface CollapsiblesState {
  [key: string]: Collapsible;
}

// Initial state
function getCollapsedFromLocalStorage() {
  const sidebar = getSidebarValues();
  if (sidebar && sidebar.collapsedDrawerSections) {
    return sidebar.collapsedDrawerSections.reduce((prev, sectionId) => {
      return {
        ...prev,
        [sectionId]: {
          open: false,
        },
      };
    }, {});
  }
}

const initialState: CollapsiblesState = {
  ...getCollapsedFromLocalStorage(),
};

// Action types
const TOGGLE_COLLAPSIBLE = Symbol('ui/TOGGLE_COLLAPSIBLE');

// Reducer
export default createReducer(initialState, {
  // tslint:disable-next-line:no-any
  [TOGGLE_COLLAPSIBLE](state: CollapsiblesState, { payload }: any) {
    const { id, open } = payload;

    return {
      ...state,
      [id]: {
        open: state[id] ? !state[id].open : !open,
      },
    };
  },
});

// Side effects
const updateLocalStorage = (state: CollapsiblesState) => {
  const localStorageValues = getSidebarValues();
  if (localStorageValues) {
    const collapsedSections = state ? Object.keys(state) : [];
    const localStorageUpdate = {
      ...localStorageValues,
      collapsedDrawerSections: collapsedSections.filter(
        (section) => !state[section].open,
      ),
    };
    setSidebarValues(localStorageUpdate);
  }
};

// Action creators
const toggleCollapsibleAction = actionCreator(TOGGLE_COLLAPSIBLE);

// Actions
export const toggleCollapsible = (
  collapsibles: CollapsiblesState,
): StandardThunkAction => {
  return async (dispatch, getState) => {
    dispatch(toggleCollapsibleAction(collapsibles));

    updateLocalStorage(getCollapsedDrawerSections(getState()));
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/collapsibles.ts